import React, { useEffect, useState } from "react";
import AxiosInstance from "../../../../../services/Api";
import {
  CustomButton,
  CustomCheckbox,
  CustomTextInput,
} from "../../../../../components";
import styles from "./ChecklistPopup.module.css";
import PopupModal from "../../../../../components/PopupModal/PopupModal";
import { useSelector } from "react-redux";

const ChecklistPopup = ({
  id,
  is_secondary,
  onCancel,
  fetchAdmissionList,
  user_id,
  checklistData,
}) => {
  const { translations } = useSelector((state) => state.language);
  const t = translations?.labels;

  const [modalState, setModalState] = useState({
    open: false,
    type: "",
    message: "",
  });
  const [checklistOptions, setChecklistOptions] = useState([]);
  const [selectedChecklist, setSelectedChecklist] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  // -----------------------------
  // Fetch Checklist API
  // -----------------------------
  const fetchChecklist = async () => {
    setLoading(true);
    try {
      const response = await AxiosInstance.post("/admission/Checklist", {
        id: id,
        is_secondary: is_secondary,
      });

      if (response?.data?.status) {
        const list = response?.data?.data || [];

        const options = list.map((item) => ({
          label: item.domain_id,
          value: item.id,
        }));

        const checkedItems = list
          .filter((item) => item.is_selected === 1)
          .map((item) => item.id);

        setChecklistOptions(options);
        setSelectedChecklist(checkedItems);
      }
    } catch (error) {
      console.error("Checklist fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchChecklist();
    }
  }, [id]);

  // -----------------------------
  // Checkbox change
  // -----------------------------
  const handleChecklistChange = (value) => {
    setSelectedChecklist(value);
  };

  // -----------------------------
  // Update Checklist
  // -----------------------------
  const handleUpdate = async () => {
    setSubmitting(true);
    try {
      const payload = {
        id: id,
        is_secondary: is_secondary,
        checkListId: selectedChecklist,
        created_by: user_id,
      };

      const response = await AxiosInstance.post(
        "/admission/checkListUpdate",
        payload,
      );

      if (response?.data?.status) {
        setModalState({
          open: true,
          type: "success",
          message:
            response?.data?.message ||
            t?.checklistUpdateSuccess ||
            "Checklist updated successfully",
        });
        fetchAdmissionList();
      } else {
        setModalState({
          open: true,
          type: "error",
          message:
            response?.data?.message ||
            t?.checklistUpdateFailed ||
            "Checklist update failed",
        });
      }
    } catch (error) {
      setModalState({
        open: true,
        type: "error",
        message:
          t?.somethingWentWrongTryAgain ||
          "Something went wrong. Please try again.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  const handleModalClose = () => {
    setModalState({ open: false, type: "", message: "" });
    onCancel();
  };

  return (
    <div className={styles.popupContainer}>
      <h5 className={styles.title}>{t?.checkList || "Check List"}</h5>

      <div className="row">
        {/* Application ID */}
        <div className="col-12 mb-3">
          <CustomTextInput
            label={t?.applicationId || "Application ID"}
            name="applicationId"
            type="text"
            value={checklistData?.application_no}
            disabled
          />
        </div>

        {/* Admission Type */}
        <div className="col-12 mb-3">
          <CustomTextInput
            label={t?.admissionType || "Admission Type"}
            name="admissionType"
            type="text"
            value={is_secondary === 1 ? "VI-X" : "XI-XII"}
            disabled
          />
        </div>

        {/* Checklist */}
        <div className="col-12 mb-3">
          <CustomCheckbox
            label={t?.checklistItems || "Checklist Items"}
            name="checklist"
            options={checklistOptions}
            value={selectedChecklist}
            onChange={handleChecklistChange}
            inline={false}
          />
        </div>

        {/* Buttons */}
        <div className="col-12 mt-3">
          <div className={styles.buttonContainer}>
            <CustomButton
              type="button"
              variant="outlined"
              onClick={onCancel}
              disabled={submitting}
            >
              {t?.cancel || "Cancel"}
            </CustomButton>

            <CustomButton
              type="button"
              variant="contained"
              onClick={handleUpdate}
              disabled={submitting || loading}
              loading={submitting}
              loadingText={t?.updating || "Updating..."}
            >
              {t?.update || "Update"}
            </CustomButton>
          </div>
        </div>
      </div>

      <PopupModal
        open={modalState.open}
        title={
          modalState.type === "success"
            ? t?.success || "Success"
            : t?.failed || "Failed"
        }
        message={modalState.message}
        onClose={handleModalClose}
      />
    </div>
  );
};

export default ChecklistPopup;
